import React from 'react'
import ReactDOM from 'react-dom'

import { ConnectedApp } from '@app/App'
import 'component-library-next/build/styles/foundation.scss'
import './index.scss'

ReactDOM.render(<ConnectedApp />, document.getElementById('root'))
